module.exports = __webpack_public_path__ + "img/add-to-cart-mobile-icon.16220d5b.svg";